import * as React from 'react';

import PropTypes from 'prop-types';

import {FunnelSection} from './funnel-section';

export class FunnelReportView extends React.Component {
    static propTypes = {
        isBlank: PropTypes.bool.isRequired,
        json: PropTypes.object.isRequired,
        showReassigned: PropTypes.bool.isRequired,
        displayType: PropTypes.string.isRequired,
    };

    render() {
        return (
            <div className='ui-funnel-report__funnel'>
                <div className='ui-funnel-report__funnel-sections'>
                    {this.renderFunnelSections()}
                </div>
            </div>
        );
    }

    renderFunnelSections() {
        const {dashboards} = this.props.json;

        return dashboards.map((dashboard, index) => {
            return (
                <FunnelSection
                    key={dashboard.id}
                    stageNum={index + 1}
                    isBlank={this.props.isBlank}
                    isFirstSection={index === 0}
                    isLastSection={index === dashboards.length - 1}
                    maxValue={Math.max.apply(
                        null,
                        Object.keys(dashboards).map((stage) => {
                            return Number(
                                dashboards[stage].totalLeads[this.props.displayType].value
                            );
                        })
                    )}
                    displayType={this.props.displayType}
                    showReassigned={this.props.showReassigned}
                    {...dashboard}
                />
            );
        });
    }
}
